var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 13.7568C22 19.2798 17.523 23.7568 12 23.7568C6.477 23.7568 2 19.2798 2 13.7568C2 8.23484 6.477 3.75684 12 3.75684C17.523 3.75684 22 8.23484 22 13.7568Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32052 15.1313C8.72894 15.1313 8.24902 14.6515 8.24902 14.0598C8.24902 13.4682 8.7288 12.9883 9.32052 12.9883C9.91239 12.9883 10.392 13.4681 10.392 14.0598C10.392 14.6514 9.91239 15.1313 9.32052 15.1313Z",
    fill: "white",
    fillOpacity: 0.72
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3922 15.1313C14.8003 15.1313 14.3208 14.6515 14.3208 14.0598C14.3208 13.4682 14.8003 12.9883 15.3922 12.9883C15.9838 12.9883 16.4637 13.4681 16.4637 14.0598C16.4637 14.6514 15.9839 15.1313 15.3922 15.1313Z",
    fill: "white",
    fillOpacity: 0.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3929 15.8453C14.4066 15.8453 13.607 15.0458 13.607 14.0596C13.607 13.0735 14.4066 12.2739 15.3929 12.2739C16.3791 12.2739 17.1786 13.0735 17.1786 14.0596C17.1786 15.0458 16.3791 15.8453 15.3929 15.8453ZM12.8929 14.3276C12.7449 14.3276 12.6249 14.2076 12.6249 14.0598C12.6249 13.9119 12.7449 13.7918 12.8929 13.7918C13.0407 13.7918 13.1607 13.9118 13.1607 14.0598C13.1607 14.2076 13.0407 14.3276 12.8929 14.3276ZM11.8214 14.3276C11.6735 14.3276 11.5534 14.2076 11.5534 14.0598C11.5534 13.9119 11.6734 13.7918 11.8214 13.7918C11.9692 13.7918 12.0892 13.9118 12.0892 14.0598C12.0892 14.2076 11.9692 14.3276 11.8214 14.3276ZM9.32131 15.8453C8.33515 15.8453 7.53561 15.0458 7.53561 14.0596C7.53561 13.0735 8.33515 12.2739 9.32131 12.2739C10.3076 12.2739 11.1071 13.0735 11.1071 14.0596C11.1071 15.0458 10.3076 15.8453 9.32131 15.8453ZM9.32131 9.7739H15.3929V11.381H9.32131V9.7739ZM15.9286 11.381V9.23828H8.7857V11.381H7V16.7382H17.7143V11.381H15.9286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioBox);
export default __webpack_public_path__ + "static/media/radio_box.fe14ff4581617ccc95c7619c32a6ee84.svg";
export { ForwardRef as ReactComponent };